var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseSummarizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 6.66667,
    rx: 3,
    fill: "#3D9DE2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13.333,
    width: 13.3333,
    height: 14.6667,
    rx: 3,
    fill: "#3D9DE2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3333,
    y: 13.333,
    width: 6.66667,
    height: 14.6667,
    rx: 3,
    fill: "#3D9DE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseSummarizer);
export default __webpack_public_path__ + "static/media/caseSummarizer.59f13f0b771fd16c3493f143041892ea.svg";
export { ForwardRef as ReactComponent };